import { render, staticRenderFns } from "./ListCard.vue?vue&type=template&id=31b6f46a&scoped=true"
import script from "./ListCard.vue?vue&type=script&lang=js"
export * from "./ListCard.vue?vue&type=script&lang=js"
import style0 from "./ListCard.vue?vue&type=style&index=0&id=31b6f46a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b6f46a",
  null
  
)

export default component.exports